export default __webpack_public_path__ + "static/media/Number_2_selected_hsb.a2dd5a24.svg";